module.exports = __webpack_public_path__ + "img/MD_425x472px-mobile.060b8e8.webp";